/**
 * Maps an array of data items to a template.
 * @param {Array} results
 * @param {jQuery} $itemTemplate
 * @return {Element[]}
 */
const mapSuggestionDataToTemplate = (results, $itemTemplate) => (
    results.map(entry => {
        const $item = $itemTemplate.clone();
        $item.find('a').text(entry);

        return $item.get(0);
    })
);

export default mapSuggestionDataToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/search/mapSuggestionDataToTemplate.js